import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { WhatYouGet } from "@/components/WhatYouGet";
import { Manifesto } from "@/components/Manifesto";
import { SocialProof } from "@/components/SocialProof";
import { CheckoutSection } from "@/components/CheckoutSection";
import { FinalCTA } from "@/components/FinalCTA";
import { scrollToId } from "@/lib/scroll";

const IntroCurtain = () => (
    <motion.div
        data-testid="intro-curtain"
        className="fixed inset-0 z-[90] bg-black flex items-center justify-center"
        exit={{ y: "-100%" }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
        <motion.span
            initial={{ opacity: 0, letterSpacing: "0.1em" }}
            animate={{ opacity: 1, letterSpacing: "0.6em" }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="font-serif uppercase text-gold text-2xl sm:text-3xl"
        >
            TS
        </motion.span>
    </motion.div>
);

const Spotlight = () => {
    const [pos, setPos] = useState({ x: -500, y: -500 });
    useEffect(() => {
        const move = (e) => setPos({ x: e.clientX, y: e.clientY });
        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, []);
    return (
        <div
            className="hidden lg:block fixed inset-0 z-[5] pointer-events-none"
            style={{ background: `radial-gradient(500px circle at ${pos.x}px ${pos.y}px, rgba(168,85,247,0.08), transparent 70%)` }}
        />
    );
};

export default function LandingPage() {
    const [intro, setIntro] = useState(true);

    useEffect(() => {
        const t = setTimeout(() => setIntro(false), 1100);
        return () => clearTimeout(t);
    }, []);

    useEffect(() => {
        if (new URLSearchParams(window.location.search).get("cancelled")) {
            setTimeout(() => scrollToId("checkout"), 300);
        }
    }, []);

    return (
        <div data-testid="landing-page" className="relative bg-[#0B0614] text-white min-h-screen">
            <AnimatePresence>{intro && <IntroCurtain />}</AnimatePresence>
            <Spotlight />
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <WhatYouGet />
                <Manifesto />
                <SocialProof />
                <CheckoutSection />
                <FinalCTA />
            </main>
        </div>
    );
}
